import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqAssignProvider');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'assigned_providers',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqAssignProvider.js